import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=ecc95baa&scoped=true&"
var script = {}
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=ecc95baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc95baa",
  null
  
)

export default component.exports